// removed by extract-text-webpack-plugin
module.exports = {"sea-overlay":"dh-dh-plastic-counter-sea-overlay"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/SeaOverlay.css
// module id = 32
// module chunks = 0